
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGround2 as ObiGround2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-ground-2.js';
 
 
 

 
 export const ObiGround2 = createComponent({
   react: React,
   tagName: 'obi-ground-2',
   elementClass: ObiGround2Element,
   events: {
     
   }
  });
 
 